import React from 'react'
import { Box } from 'rebass'
import { useSTheme } from 'styles/theme'
import FLabel from '../FLabel'
import FParagraphGroup from '../Text/FParagraphGroup'
import ConditionalRender from 'utils/conditionalRender'
import { TextAreaContainerStyled } from './styles'

type FTextAreaProps = {
    label?: string
    paragraphs: string[]
}

const FTextArea = React.forwardRef((props: FTextAreaProps, ref) => {
    const { label, paragraphs, ...otherProps } = props
    const theme = useSTheme()

    return (
        <Box mt={'24px'}>
            <ConditionalRender if={label}>
                <FLabel color={theme.colors.gray400} sx={{ fontWeight: 700 }}>
                    {label}
                </FLabel>
            </ConditionalRender>
            <TextAreaContainerStyled>
                <FParagraphGroup
                    paragraphs={paragraphs}
                    textStyles={{ fontSize: '12px', lineHeight: '16px' }}
                ></FParagraphGroup>
            </TextAreaContainerStyled>
        </Box>
    )
})

FTextArea.displayName = 'FTextArea'

export default FTextArea
